import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import LeadForm from '../../../components/forms/LeadForm';
import { LeadClient, LeadDTO, LeadFileDTO } from '../../../services/apiClient';
import { useNavigate, useParams } from 'react-router-dom';
import { API_BASE_URL } from '../../../config/config';
import axiosInstance from '../../../services/axiosInstance';
import { handleFileSubmit } from '../../../utils/leadUtils/handleFileSubmit';
import { handleNoteSubmit } from '../../../utils/leadUtils/handleNoteSubmit';
import Card from '../../../components/common/Card';

const LeadEdit: React.FC = () => {
  const [entityData, setEntityData] = useState<LeadDTO | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const apiClient = new LeadClient(API_BASE_URL, axiosInstance);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Leads', href: '/admin/leads' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await apiClient.getLeadById(id!);
        setEntityData(response.data || null);
      } catch (error) {
        console.error('Error fetching Lead data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any, submitFiles: LeadFileDTO[], submitNotes: string[]) => {
    setIsSubmitting(true);
    try {
      var response = await apiClient.updateLead(id!, data);
      if (response && response.success) {
        await handleFileSubmit(response.data, submitFiles);
        if (submitNotes && submitNotes.length > 0) {
          await handleNoteSubmit(id, submitNotes);
        }
        navigate('/admin/leads');
      }
    } catch (error) {
      console.error('Error updating Lead:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/leads"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Administrator', 'User']}
    >
      {entityData ? (
        <Card title="Edit Lead">
          <LeadForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/leads')}
          />
        </Card>

      ) : (
        <p>Loading...</p>
      )}
    </AdminLayout>
  );
};

export default LeadEdit;
